import slugify from '@sindresorhus/slugify';

import DefaultCard from '@/components/DefaultCard';

export default function CardList({
  entries = [],
  Component = DefaultCard,
  linkSubpath,
}) {
  return (
    <div className="space-y-6 md:space-y-12">
      {entries.map((entry) => (
        <Component
          key={entry.id}
          linkPath={`/${linkSubpath}/${slugify(entry.slug, { lower: true })}`}
          {...entry}
        />
      ))}
    </div>
  );
}
